export default __webpack_public_path__ + "static/media/Domo.2fc6559d.png";